"use strict";

class Form {
    toggleActive(event) {
        const switchInput = $(event.target),
            form = switchInput.closest("form");

        $.ajax({
            headers: {
                "X-CSRF-Token": form.find('input[name="_token"]').val(),
            },
            url: form.attr("action"),
            type: "PATCH",
            data: { is_active: switchInput.data("isactive") },
        });
    }
}

export default Form;
